import { Pipe, PipeTransform } from '@angular/core'
import { Venue } from '@app/domain/Venue'

@Pipe({
    name: 'eventName',
    standalone: true,
})
export class EventNamePipe implements PipeTransform {

    transform(eventId: string, venue: Venue): string | null {
        const event = venue.eventWithId(eventId)
        return event ? event.displayName : null
    }
}
